import { render, staticRenderFns } from "./item_dropdown.vue?vue&type=template&id=39860925&scoped=true&"
import script from "./item_dropdown.vue?vue&type=script&lang=js&"
export * from "./item_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./item_dropdown.vue?vue&type=style&index=0&id=39860925&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39860925",
  null
  
)

export default component.exports